<template>
	<v-dialog v-model="dialog" @click:outside="$emit('onClose')" max-width="590">
      <v-card>
        <v-card-title class="headline pl-4">
           Veuillez sélectionner un droit utilisateur
        </v-card-title>

        <v-card-text>
          <v-combobox
            v-model="selectedUserRight"
            :items="userRights"
            :loading="isLoading"
            :search-input.sync="search"
            hide-no-data
            hide-selected
            item-text="name"
            item-value="@id"
            label="Liste des droits utilisateurs"
            placeholder="Commencer à taper un droit utilisateur pour rechercher ... "
            prepend-icon="mdi-database-search"
            return-object
          ></v-combobox>
        </v-card-text>

        <v-divider></v-divider>

        <v-expand-transition>
          <div v-if="selectedUserRight !== null">
            <p class="pl-4">
              Nom du droit utilisateur  : {{ selectedUserRight.name }}</p>
          </div>
        </v-expand-transition>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="orange darken-1" text @click="$emit('onClose')">
            Annuler
          </v-btn>

          <v-btn color="blue darken-1" text @click="selectUserRight"> Valider </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>

//import Api from "@/core/services/api.service";

export default {
  data: () => ({
    isLoading: false,
    selectedUserRight: null,
    search: null,
    //userRights: [],
  }),
  props: {
    dialog: Boolean,
    userRights: Array,
  },
  computed: {
    apiUrl() {
      return process.env.VUE_APP_API;
    },
  },
  methods: {
    selectUserRight() {
      this.$emit("selectUserRight", this.selectedUserRight);
      this.selectedUserRight = null;
    },
  },

  // watch: {
  //   search(value) {
  //     if (this.isLoading) return;
  //     this.isLoading = true;
  //     Api.query("user_rights", { params: { name: value } })
  //       .then(userRights => {
  //         this.userRights = userRights.data["hydra:member"];
  //       })
  //       .catch((err) => {
  //         console.log(err);
  //       })
  //       .finally(() => (this.isLoading = false));
  //   },
  // },

};
</script>
